import { render, staticRenderFns } from "./ExtinguisherOrganize2205.vue?vue&type=template&id=4546c322&scoped=true"
import script from "./ExtinguisherOrganize2205.vue?vue&type=script&lang=js"
export * from "./ExtinguisherOrganize2205.vue?vue&type=script&lang=js"
import style0 from "./ExtinguisherOrganize2205.vue?vue&type=style&index=0&id=4546c322&prod&scoped=true&lang=css"
import style1 from "./ExtinguisherOrganize2205.vue?vue&type=style&index=1&id=4546c322&prod&lang=css"
import style2 from "./ExtinguisherOrganize2205.vue?vue&type=style&index=2&id=4546c322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546c322",
  null
  
)

export default component.exports